export default (root:any) => {
  const unauthenticatedMenu = [
    {
      id: 1,
      link: root.t('websiteLinks.home'),
      linktext: root.t('header.freeflexers'),
      permission: true
    },
    {
      id: 2,
      link: root.t('websiteLinks.companies'),
      linktext: root.t('header.companies'),
      permission: true
    },
    {
      id: 3,
      link: root.t('websiteLinks.story'),
      linktext: root.t('header.story'),
      permission: true
    },
  ]
  return {
    unauthenticatedMenu,
  }
}
